import React from 'react';
import { FadeIn } from './FadeIn';
import { motion } from 'framer-motion';
export function FinalCTA() {
  return <section className="py-6 md:py-20 px-4 bg-celeste" data-id="element-58">
      <div className="max-w-4xl mx-auto text-center" data-id="element-59">
        <FadeIn data-id="element-60">
          <motion.a href="https://brandersecomm.myshopify.com/cart/add?id=50694869188855&quantity=1" whileHover={{
          scale: 1.05
        }} whileTap={{
          scale: 0.95
        }} className="inline-block w-full md:w-auto bg-white text-celeste font-display font-black text-xl md:text-3xl lg:text-4xl py-6 md:py-8 px-6 md:px-16 rounded-2xl uppercase tracking-tight shadow-2xl hover:bg-gray-50 transition-colors" data-id="element-61">
            👉 QUIERO EL EBOOK Y EMPEZAR HOY
          </motion.a>
        </FadeIn>
      </div>
    </section>;
}